import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.pbl');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-pbl',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.pbl/view.scss */
:host {
  display: block;
  min-height: 100vh;
}

.pbl-shell {
  min-height: 100vh;
  background: radial-gradient(circle at 10% 0%, rgba(15, 118, 110, 0.12), transparent 34rem), radial-gradient(circle at 100% 14%, rgba(234, 88, 12, 0.08), transparent 28rem), #f3f5f2;
}`],
})
export class LayoutPblComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.render();
    }
}

export default LayoutPblComponent;